
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailLogsTable } from "./EmailLogsTable";
import { EmailTestSection } from "./EmailTestSection";
import { SmtpSettings } from "./SmtpSettings";
import { TemplateManager } from "./TemplateManager";
import WaitlistNotificationPanel from "../waitlist-settings/WaitlistNotificationPanel";
import { useEmailSettings } from "@/hooks/admin/settings/useEmailSettings";
import { useIsMobile } from "@/hooks/use-mobile";

export const EmailDashboard = () => {
  const { settings, handleInputChange, isLoading, saveSettings } = useEmailSettings();
  const isMobile = useIsMobile();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Email Dashboard</h2>
        <p className="text-muted-foreground">
          Monitor email deliveries and manage email settings
        </p>
      </div>

      <Tabs defaultValue="logs" className="w-full">
        {/* Responsive tabs layout for mobile */}
        <TabsList className={`${isMobile ? "w-full grid grid-cols-2 gap-2 mb-4" : ""}`}>
          <TabsTrigger 
            value="logs" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Delivery Logs
          </TabsTrigger>
          <TabsTrigger 
            value="settings" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Settings
          </TabsTrigger>
          <TabsTrigger 
            value="templates" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Templates
          </TabsTrigger>
          <TabsTrigger 
            value="test" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Test Email
          </TabsTrigger>
          <TabsTrigger 
            value="waitlist" 
            className={isMobile ? "text-sm py-2" : ""}
          >
            Waitlist
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="logs" className="mt-6">
          <EmailLogsTable />
        </TabsContent>
        
        <TabsContent value="settings" className="mt-6">
          {isLoading ? (
            <div className="py-10 text-center">Loading settings...</div>
          ) : (
            <SmtpSettings 
              settings={settings} 
              onInputChange={handleInputChange}
              saveSettings={saveSettings}
            />
          )}
        </TabsContent>

        <TabsContent value="templates" className="mt-6">
          <TemplateManager />
        </TabsContent>
        
        <TabsContent value="test" className="mt-6">
          <EmailTestSection 
            fromAddress={settings.fromAddress} 
            onFromAddressChange={(fromAddress) => handleInputChange('fromAddress', fromAddress)} 
          />
        </TabsContent>

        <TabsContent value="waitlist" className="mt-6">
          <WaitlistNotificationPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};
